var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCamera(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 36,
    viewBox: "0 0 45 36"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M14.56.055l27.204 16.009-6.981 11.933-9.442-5.555-4.078.253-2.096 3.641c.27.5.423 1.072.423 1.68a3.531 3.531 0 01-3.526 3.536 3.523 3.523 0 01-3.23-2.123H7.771v2.882H3.885v2.744H0V21.733h3.885v2.468h3.887v2.345h5.089a3.522 3.522 0 013.203-2.066c.275 0 .541.035.798.094l2.067-3.588-1.828-3.393L7.58 11.99 14.56.055zm27.76 18.64L45 21.63l-3.778 6.517-3.901-.904 4.998-8.546z"
  })));
}

export default SvgCamera;